import { Accordion } from './../Accordion';
import { Title } from './../Typography';
import { Grid, GridItem, GridRow } from './../Grid';
import React, { ReactElement } from 'react';
import { AccordianBodyContainer, Wrapper } from './styles';
import { CorpAccordionNumberIcon } from '../Icons/icons';

export function CorpGenericAccordion({
  id = 'corp-generic-accordion',
  data,
  $isNumbered,
  getItemBody,
}: {
  id?: any;
  data: any;
  getItemBody(bodyItems: Array<{ id: string; __typename: string }>): ReactElement[];
  $isNumbered: boolean;
}) {
  const name = 'CorpGenericAccordion';
  const accordionData = data.map((item: any, index: number) => {
    const title = (
      <Title tag="div" type="xs" key={`${item?.title}-${index}-title`}>
        {item.title}
      </Title>
    );
    const body = (
      <AccordianBodyContainer $isReverse key={`${item?.title}-${index}-body`}>
        {item.genericAccordionItemBodyComponents?.length > 0 && (
          <div>{getItemBody(item.genericAccordionItemBodyComponents)}</div>
        )}
      </AccordianBodyContainer>
    );
    return {
      title,
      body,
    };
  });

  function HeadingWrapper({
    children,
  }: {
    children: React.ElementType;
  }): ReactElement<any, any> | null {
    return <>{children}</>;
  }

  return (
    <Grid>
      <GridRow columns={16}>
        <GridItem colStart={2} colSpan={14}>
          <Wrapper>
            <Accordion
              data-test={`${id}-generic-accordion`}
              name={name}
              data={accordionData}
              collapsed={true}
              NumberedSvg={CorpAccordionNumberIcon}
              HeadingWrapper={HeadingWrapper}
              $isNumbered={$isNumbered}
            />
          </Wrapper>
        </GridItem>
      </GridRow>
    </Grid>
  );
}
